// ============================================================================
// PendingApproval — what a person sees after signing up, until HQ decides.
//   pending   → "HQ is reviewing your details"
//   declined  → shows HQ's reason
//   suspended → "Your account is paused"
// ============================================================================
import { T } from '../../utils';
import { FontLink } from '../../components/UI';

export default function PendingApproval({ profile, onSignOut }) {
  const firstName = (profile.full_name || '').split(' ')[0] || 'friend';

  let title; let body;
  if (profile.status === 'declined') {
    title = 'Your sign-up was not approved';
    body = profile.declined_reason || 'Please contact HQ for more information.';
  } else if (profile.status === 'suspended') {
    title = 'Your account is paused';
    body = 'Your account is paused. Contact HQ.';
  } else {
    title = `Thank you, ${firstName}.`;
    body = 'HQ is reviewing your details. You will get full access as soon as you are approved — please check back soon.';
  }

  return (
    <div style={{ minHeight: '100vh', background: T.cream, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, fontFamily: "'DM Sans',sans-serif" }}>
      <FontLink />
      <div style={{ background: T.white, borderRadius: 16, padding: '40px 32px', maxWidth: 460, textAlign: 'center', boxShadow: '0 12px 40px rgba(0,0,0,0.08)' }}>
        <img src="/logo192.png" alt="CCN" style={{ width: 72, height: 72, objectFit: 'contain', marginBottom: 16 }} />
        <div style={{ fontSize: 22, fontWeight: 700, color: T.navy, fontFamily: "'Playfair Display',serif", marginBottom: 12 }}>{title}</div>
        <div style={{ fontSize: 14, color: T.grey600, lineHeight: 1.7, marginBottom: 24 }}>{body}</div>
        <button onClick={onSignOut}
          style={{ padding: '10px 24px', borderRadius: 8, background: T.navy, color: '#fff', border: 'none', cursor: 'pointer', fontWeight: 600 }}>
          Sign out
        </button>
      </div>
    </div>
  );
}
